// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

// "lib/exports/eslint-bulk" is the entry point for the @rushstack/eslint-bulk command line front end.

require('../eslint-bulk-suppressions/cli/start');
